module.exports = __webpack_public_path__ + "media/clap-surprise.7341877e.mp3";